module.exports = __webpack_public_path__ + "static/img/icon02.c8c7a08b.svg";